import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import GridContainer from "components/Grid/GridContainer.js";

import GridItem from "components/Grid/GridItem.js";

import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { API_BASE_URL } from "views/api"
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      {props.type !== 'municipality' && <TableRow className={classes.root}onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="right" style={{ fontFamily: 'nepali-font' }}>{row.count} कार्यालयहरु</TableCell>
        <TableCell align="right"></TableCell>
        <TableCell align="right"></TableCell>
      </TableRow>}
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={props.type === 'municipality' ? true : open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              {props.type !== 'municipality' && <Typography variant="h6" gutterBottom component="div">
                {row.name}
              </Typography>}
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell><b>कार्यालय</b></TableCell>
                    <TableCell><b>{props.type !== 'municipality' ? "प्रमुख व्यक्ति (पद)": 'शाखा प्रमुख'}</b></TableCell>
                    <TableCell><b>फोन नं.</b></TableCell>
                    <TableCell><b>{props.type !== 'municipality' ? 'वेबसाईट' : 'कार्यालयको ठेगाना / कोठा नं.'}</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.data.map((historyRow) => (
                    <TableRow key={historyRow.office}>
                      <TableCell component="th" scope="row">
                        {historyRow.office}
                      </TableCell>
                      <TableCell>{historyRow.contactPerson}</TableCell>
                      <TableCell style={{ fontFamily: 'nepali-font' }}>{historyRow.contactNumber}</TableCell>
                      {props.type !== 'municipality' ?
                        <TableCell>{historyRow.website}</TableCell>
                        :
                        <TableCell>{historyRow.location}</TableCell>
                      }
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    count: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        contactNumber: PropTypes.number.isRequired,
        contactPerson: PropTypes.string.isRequired,
        office: PropTypes.string.isRequired,
        website: PropTypes.string.isRequired,
      }),
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};
const useStyles = makeStyles(styles);

export default function CollapsibleTable(props) {
  const classes = useStyles();

  const government_offices_location = (selected_data)=> {return({
    'bhaktapur_ddc': API_BASE_URL + 'introduction/government-office/?administrative_unit=bhaktapur_district&type='+selected_data,
    'changunarayan_municipality': API_BASE_URL + 'introduction/government-office/?administrative_unit=changunarayan&type='+selected_data,
    'bhaktapur_municipality': API_BASE_URL + 'introduction/government-office/?administrative_unit=bhaktapur&type='+selected_data,
    'madhyapur_thimi_municipality': API_BASE_URL + 'introduction/government-office/?administrative_unit=madhyapur_thimi&type='+selected_data,
    'suryabinayak_municipality': API_BASE_URL + 'introduction/government-office/?administrative_unit=suryabinayak&type='+selected_data,
  });}

  const municipality_name_map = {
    bhaktapur_ddc: {
      name: 'भक्तपुर जि.स.स.',
    },
    changunarayan_municipality: {
      name: 'चाँगुनारायण नगर कार्यपालिका',
    },
    bhaktapur_municipality: {
      name: 'भक्तपुर नगर कार्यपालिका',
    },
    madhyapur_thimi_municipality: {
      name: 'मध्यपुर थिमि नगर कार्यपालिका',
    },
    suryabinayak_municipality: {
      name: 'सूर्यविनायक नगर कार्यपालिका',
    },
  }

  const [federal_government_detail, setFederalGovernment] = React.useState(undefined);
  const [state_government_detail, setStateGovernment] = React.useState(undefined);
  const [district_other_offices_detail, setDistrictOtherOffices] = React.useState(undefined);
  const [ward_offices_detail, setWardOffices] = React.useState(undefined);
  const [branch_offices_detail, setBranchOffices] = React.useState(undefined);

  React.useEffect(() => {
    if (federal_government_detail === undefined) {
      fetch(government_offices_location('federal_government')[props.selected_data])
        .then(results => results.json())
        .then(data => {
          setFederalGovernment(data.results);
        });
    }
  });
  React.useEffect(() => {
    if (state_government_detail === undefined) {
      fetch(government_offices_location('state_government')[props.selected_data])
        .then(results => results.json())
        .then(data => {
          setStateGovernment(data.results);
        });
    }
  });
  React.useEffect(() => {
    if (district_other_offices_detail === undefined) {
      fetch(government_offices_location('district_other_offices')[props.selected_data])
        .then(results => results.json())
        .then(data => {
          setDistrictOtherOffices(data.results);
        });
    }
  });
  React.useEffect(() => {
    if (ward_offices_detail === undefined) {
      fetch(government_offices_location('ward_offices')[props.selected_data])
        .then(results => results.json())
        .then(data => {
          setWardOffices(data.results);
        });
    }
  });
  React.useEffect(() => {
    if (branch_offices_detail === undefined) {
      fetch(government_offices_location('branch_offices')[props.selected_data])
        .then(results => results.json())
        .then(data => {
          setBranchOffices(data.results);
        });
    }
  });

  const district_row = () => [
    {
      name: 'संघिय सरकार मातहतका कार्यालयहरु',
      count: federal_government_detail.length,
      data: federal_government_detail.map((office) => {
        return ({
          'office': office.name,
          'contactPerson': office.contact_person,
          'contactNumber': office.contact_number,
          'website': office.website
        });
      })
    },{
      name: 'प्रदेश सरकार अन्तर्गतका कार्यालयहरु',
      count: state_government_detail.length,
      data: state_government_detail.map((office) => {
        return ({
          'office': office.name,
          'contactPerson': office.contact_person,
          'contactNumber': office.contact_number,
          'website': office.website
        });
      })
    },{
      name: 'जिल्लामा रहेका अन्य कार्यालयहरु',
      count: district_other_offices_detail.length,
      data: district_other_offices_detail.map((office) => {
        return ({
          'office': office.name,
          'contactPerson': office.contact_person,
          'contactNumber': office.contact_number,
          'website': office.website
        });
      })
    }
  ]

  const municipality_row = () => [
    // {
    //   name: 'स्थानीय तह: वडा कार्यालयहरुको जानकारी',
    //   count: ward_offices_detail.length,
    //   data: ward_offices_detail.map((office) => {
    //     return ({
    //       'office': office.name,
    //       'contactPerson': office.contact_person,
    //       'contactNumber': office.contact_number,
    //       'website': office.website
    //     });
    //   })
    // }
    // ,
    {
      name: municipality_name_map[props.selected_data].name + 'का रहेका शाखा कार्यालयहरु',
      count: branch_offices_detail.length,
      data: branch_offices_detail.map((office) => {
        return ({
          'office': office.name,
          'contactPerson': office.contact_person,
          'contactNumber': office.contact_number,
          'location': office.location
        });
      })
    }
  ]

  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0}}>
            <small>जानकारी</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>{props.selected_data === 'bhaktapur_ddc' ? 'भक्तपुर जिल्लामा रहेका सरकारी कार्यालयहरु' : municipality_name_map[props.selected_data].name + 'का शाखा कार्यालयहरु'}</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
          <GridContainer style={{margin: 'auto', color: '#333'}} xs={12} sm={12} md={10}>
            {props.selected_data === 'bhaktapur_ddc' && <div style={{ padding: '10px', width: '100%', margin: 'auto' }}>विस्तृत जानकारीको लागि तल कार्यालयको प्रकार छान्नुहोस:</div>}
            <TableContainer component={Paper} style={props.type !== 'municipality' ? { marginTop: '20px' }:{}}>
              <Table aria-label="collapsible table">
                <TableBody>
                  { props.selected_data === 'bhaktapur_ddc' &&
                    federal_government_detail &&
                    state_government_detail &&
                    district_other_offices_detail &&
                  district_row().map((row, i) => (
                    <Row key={row.name} row={row}/>
                  ))}
                  { props.selected_data !== 'bhaktapur_ddc' &&
                    branch_offices_detail &&
                  municipality_row().map((row, i) => (
                    <Row key={row.name} row={row} type="municipality"/>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>

  );
}
